export const environment = {
	production: true,
	apiUrl: '/api',
    pusherKey: 'scap897079688e2xx04dff4b23613228',
	tolgeeApiUrl: 'https://tolgee.modesk.io',
  	tolgeeApiKey: 'tgpak_gnpwm2lvnjvxg2rznnzts5rynu2haz3vnvwxaobrgzwts',
  	enableTolgeeDevTools: false,

	sentryDSN: null,
		socketUrl: "http:nginx",

	CLOUD_URL: null,
};
